module.exports = __webpack_public_path__ + "static/img/cont1901.bc4d8c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont1901.jpg
// module id = zz6S
// module chunks = 0